
/* Yeast Bakers shade matcher.
   Hex values sampled from the real swatch artwork. Availability, handles and
   variant IDs come from the live catalogue at runtime. */
var YB_HEX = {"colourmill-baby-blue":["Baby Blue","#A7D4EE"],"colourmill-baby-pink":["Baby Pink","#F4B7D1"],"colourmill-black":["Black","#141414"],"colourmill-blue-bell":["Blue Bell","#B3C8DB"],"colourmill-blush":["Blush","#F1D3CE"],"colourmill-burgundy":["Burgundy","#80334A"],"colourmill-candy":["Candy","#FC7FBB"],"colourmill-caramel":["Caramel","#E09933"],"colourmill-chocolate":["Chocolate","#6A402E"],"colourmill-clay":["Clay","#A76D39"],"colourmill-cobalt":["Cobalt","#1581FC"],"colourmill-coffee":["Coffee","#5E5149"],"colourmill-concrete":["Concrete","#B8BBBB"],"colourmill-coral":["Coral","#F86F66"],"colourmill-denim":["Denim","#6577A0"],"colourmill-dusk":["Dusk","#D7A0A2"],"colourmill-emerald":["Emerald","#128F79"],"colourmill-eucalyptus":["Eucalyptus","#9EAEAA"],"colourmill-forest":["Forest","#097128"],"colourmill-fuchsia":["Fuchsia","#BD2897"],"colourmill-grape":["Grape","#782365"],"colourmill-green":["Green","#23B322"],"colourmill-hot-pink":["Hot Pink","#FD0693"],"colourmill-kiwi":["Kiwi","#D6D72E"],"colourmill-latte":["Latte","#D2BEAB"],"colourmill-lavender":["Lavender","#BBAFDE"],"colourmill-lemon":["Lemon","#FBF1AD"],"colourmill-lilac":["Lilac","#EAD4E3"],"colourmill-lime":["Lime","#ABDD2C"],"colourmill-mango":["Mango","#FEAA4F"],"colourmill-mauve":["Mauve","#CCAFBC"],"colourmill-melon":["Melon","#F15476"],"colourmill-merlot":["Merlot","#A2232E"],"colourmill-midnight":["Midnight","#334762"],"colourmill-mint":["Mint","#B5ED9C"],"colourmill-mustard":["Mustard","#AF802A"],"colourmill-navy":["Navy","#0F3478"],"colourmill-nude":["Nude","#EBD0C3"],"colourmill-ocean":["Ocean","#477270"],"colourmill-olive":["Olive","#5C6C4B"],"colourmill-orange":["Orange","#FE7832"],"colourmill-peach":["Peach","#FBB49A"],"colourmill-pebble":["Pebble","#B0A196"],"colourmill-purple":["Purple","#8135B5"],"colourmill-raspberry":["Raspberry","#E50F61"],"colourmill-red":["Red","#EE0D36"],"colourmill-rose":["Rose","#EFABB9"],"colourmill-royal-blue":["Royal Blue","#1B4FC3"],"colourmill-rust":["Rust","#CA6C5E"],"colourmill-sage":["Sage","#B1C8B6"],"colourmill-sand":["Sand","#ECD8AD"],"colourmill-sea-mist":["Sea Mist","#98BCC2"],"colourmill-sky-blue":["Sky Blue","#53CBF0"],"colourmill-sunset":["Sunset","#E44230"],"colourmill-taupe":["Taupe","#E2D8D8"],"colourmill-teal":["Teal","#27AEB6"],"colourmill-tiffany":["Tiffany","#83DDD3"],"colourmill-violet":["Violet","#6D6FD6"],"colourmill-white":["White","#F7F7F7"],"colourmill-yellow":["Yellow","#FEEE30"]};
var YB_KICKSTARTER = ["Yellow","Orange","Red","Hot Pink","Baby Pink","Purple","Black","Chocolate","Forest","Lime","Sky Blue","Royal Blue"];

(function(){
  var root = document.getElementById('yb-matcher'); if(!root) return;
  var DROPS_FULL_16OZ = parseInt(root.dataset.dropsFull,10) || 16;
  var BASE_BODY = 9, STEPS = [1,0.5,0.25,0.125,0.0625];
  var $ = function(s){ return root.querySelector(s); };

  function hex2rgb(h){ var n=parseInt(h.slice(1),16); return [n>>16&255,n>>8&255,n&255]; }
  function rgb2hex(c){ return '#'+c.map(function(v){
    return Math.max(0,Math.min(255,Math.round(v))).toString(16).padStart(2,'0'); }).join('').toUpperCase(); }
  function rgb2lab(c){
    var f=c.map(function(v){ v/=255; return v>0.04045?Math.pow((v+0.055)/1.055,2.4):v/12.92; });
    var x=(f[0]*0.4124+f[1]*0.3576+f[2]*0.1805)/0.95047,
        y=(f[0]*0.2126+f[1]*0.7152+f[2]*0.0722),
        z=(f[0]*0.0193+f[1]*0.1192+f[2]*0.9505)/1.08883;
    var t=function(v){ return v>0.008856?Math.cbrt(v):(7.787*v+16/116); };
    x=t(x); y=t(y); z=t(z);
    return [116*y-16, 500*(x-y), 200*(y-z)];
  }
  function dE(a,b){ return Math.hypot(a[0]-b[0],a[1]-b[1],a[2]-b[2]); }

  /* Colour difference has no natural percentage, so the scale is defined here.
     Anchored so "you cannot tell them apart" lands in the mid 90s and a clearly
     different colour lands near 50, which is what a percentage implies to people.
     A naive 100-minus-difference would call a visibly wrong colour a 92% match. */
  function matchPct(d){ return Math.max(0, Math.min(100, Math.round(100 - d*2.2))); }
  function closeness(d){
    if(d<2)  return 'Spot on';
    if(d<5)  return 'Very close';
    if(d<10) return 'Close';
    if(d<18) return 'A little off';
    return 'Noticeably different';
  }

  /* Subtractive mixing: pigments absorb light, so average absorbance not RGB. */
  function absorb(c){ return c.map(function(v){ return -Math.log(Math.max(v,4)/255); }); }
  function unabsorb(a){ return a.map(function(v){ return 255*Math.exp(-v); }); }
  function mix(parts){
    var tot=parts.reduce(function(s,p){return s+p.w;},0), acc=[0,0,0];
    parts.forEach(function(p){ var a=absorb(p.rgb); for(var i=0;i<3;i++) acc[i]+=a[i]*p.w/tot; });
    return unabsorb(acc);
  }
  var WHITE=[247,247,247];
  function atStrength(rgb,s){ return mix([{rgb:rgb,w:s*BASE_BODY},{rgb:WHITE,w:BASE_BODY}]); }

  var ALL=[], LIB=[], byName={}, baseHex=root.dataset.start||'#7A3FB5', stepIdx=0, batch=16, palette='all';

  function activePalette(){
    if(palette==='kickstarter') return ALL.filter(function(s){ return YB_KICKSTARTER.indexOf(s.n)>-1; });
    return ALL;
  }
  function nearest(lab,k,pool){
    return (pool||LIB).map(function(s){ return {s:s,d:dE(s.lab,lab)}; })
      .sort(function(a,b){ return a.d-b.d; }).slice(0,k);
  }

  function findRecipe(hex){
    var tLab=rgb2lab(hex2rgb(hex)), src=activePalette();
    if(!src.length) return null;
    var pool=nearest(tLab,12,src).map(function(x){return x.s;});
    ['White','Black','Concrete'].forEach(function(n){
      var s=src.filter(function(x){return x.n===n;})[0];
      if(s && pool.indexOf(s)<0) pool.push(s);
    });
    var best=null;
    function consider(parts){
      var rgb=mix(parts), d=dE(rgb2lab(rgb),tLab);
      if(!best||d<best.d) best={d:d,rgb:rgb,parts:parts.map(function(p){return {n:p.n,w:p.w};})};
    }
    pool.forEach(function(a){ consider([{n:a.n,rgb:a.rgb,w:1}]); });
    var R2=[[1,1],[2,1],[1,2],[3,1],[1,3],[3,2],[2,3],[4,1],[1,4],[5,1],[1,5],[6,1],[1,6],[8,1],[1,8],[12,1],[1,12]];
    for(var i=0;i<pool.length;i++) for(var j=i+1;j<pool.length;j++) R2.forEach(function(r){
      consider([{n:pool[i].n,rgb:pool[i].rgb,w:r[0]},{n:pool[j].n,rgb:pool[j].rgb,w:r[1]}]); });
    var top=pool.slice(0,9);
    var R3=[[1,1,1],[2,1,1],[1,2,1],[1,1,2],[3,1,1],[1,3,1],[1,1,3],[2,2,1],[2,1,2],[1,2,2],[4,1,1],[1,4,1],[1,1,4],[8,1,1],[1,8,1],[1,1,8]];
    for(var a=0;a<top.length;a++) for(var b=a+1;b<top.length;b++) for(var c=b+1;c<top.length;c++) R3.forEach(function(r){
      consider([{n:top[a].n,rgb:top[a].rgb,w:r[0]},{n:top[b].n,rgb:top[b].rgb,w:r[1]},{n:top[c].n,rgb:top[c].rgb,w:r[2]}]); });
    return best;
  }

  var cv=$('.yb-wheel'), cx=cv.getContext('2d');
  function hsl2rgb(h,s,l){
    s/=100; l/=100;
    var k=function(n){return (n+h/30)%12;}, a=s*Math.min(l,1-l);
    var f=function(n){ return l-a*Math.max(-1,Math.min(k(n)-3,Math.min(9-k(n),1))); };
    return [f(0)*255,f(8)*255,f(4)*255];
  }
  (function(){
    var w=cv.width, r=w/2, img=cx.createImageData(w,w), d=img.data;
    for(var y=0;y<w;y++) for(var x=0;x<w;x++){
      var dx=x-r, dy=y-r, dist=Math.hypot(dx,dy), i=(y*w+x)*4;
      if(dist>r){ d[i+3]=0; continue; }
      var hue=((Math.atan2(dy,dx)*180/Math.PI)+360)%360;
      var c=hsl2rgb(hue, Math.min(100,(dist/r)*100), 50);
      d[i]=c[0]; d[i+1]=c[1]; d[i+2]=c[2]; d[i+3]=255;
    }
    cx.putImageData(img,0,0);
  })();
  function pickFrom(ev){
    var b=cv.getBoundingClientRect(), p=ev.touches?ev.touches[0]:ev;
    var x=(p.clientX-b.left)/b.width, y=(p.clientY-b.top)/b.height, dx=x-0.5, dy=y-0.5;
    if(Math.hypot(dx,dy)>0.5) return;
    var hue=((Math.atan2(dy,dx)*180/Math.PI)+360)%360;
    $('.yb-dot').style.left=(x*100)+'%'; $('.yb-dot').style.top=(y*100)+'%';
    setBase(rgb2hex(hsl2rgb(hue, Math.min(100,(Math.hypot(dx,dy)/0.5)*100), 50)));
  }
  cv.addEventListener('pointerdown', function(e){ cv.setPointerCapture(e.pointerId); pickFrom(e); });
  cv.addEventListener('pointermove', function(e){ if(e.buttons) pickFrom(e); });

  function setBase(h){ baseHex=h; renderRamp(); applyTarget(); }
  function renderRamp(){
    var rgb=hex2rgb(baseHex);
    $('.yb-ramp').innerHTML = STEPS.map(function(s,i){
      return '<button type="button" data-i="'+i+'" aria-pressed="'+(i===stepIdx)+'" style="background:'+
        rgb2hex(atStrength(rgb,s))+'" aria-label="Strength step '+(i+1)+' of 5"></button>'; }).join('');
    $('.yb-rampScale').innerHTML = STEPS.map(function(s){
      var d=Math.max(1,Math.round(DROPS_FULL_16OZ*s*(batch/16)));
      return '<span>'+d+' drop'+(d>1?'s':'')+'</span>'; }).join('');
    Array.prototype.forEach.call($('.yb-ramp').querySelectorAll('button'), function(b){
      b.addEventListener('click', function(){ stepIdx=+b.dataset.i; renderRamp(); applyTarget(); }); });
  }
  function applyTarget(){ update(rgb2hex(atStrength(hex2rgb(baseHex), STEPS[stepIdx]))); }

  function update(hex){
    var lab=rgb2lab(hex2rgb(hex));
    $('.yb-chip').style.background=hex; $('.yb-hexOut').textContent=hex;
    $('.yb-hexIn').value=baseHex; $('.yb-pick').value=baseHex.toLowerCase();
    $('.yb-dot').style.background=baseHex;
    $('.yb-batchLabel').textContent='For '+batch+' oz of frosting.';

    var near=nearest(lab,6,activePalette());
    $('.yb-tName').textContent = near.length && near[0].d<5
      ? 'Very close to '+near[0].s.n+' straight from the bottle.'
      : 'No single bottle matches, so mix it below.';
    $('.yb-matches').innerHTML = near.map(function(x){
      return '<a class="yb-m" href="/products/'+x.s.handle+'" title="'+closeness(x.d)+' (colour difference '+x.d.toFixed(1)+')">'+
        '<span class="yb-sw" style="background:'+x.s.hex+'"></span>'+
        '<span><b>'+x.s.n+'</b><em>'+matchPct(x.d)+'% match</em></span></a>'; }).join('');

    var rec=findRecipe(hex);
    if(!rec){ $('.yb-verdict').textContent='Select at least one bottle.'; $('.yb-recipe').innerHTML=''; return; }
    $('.yb-rTarget').style.background=hex; $('.yb-rMixed').style.background=rgb2hex(rec.rgb);
    $('.yb-verdict').innerHTML='<b>'+matchPct(rec.d)+'% match &mdash; '+closeness(rec.d).toLowerCase()+'.</b> Your colour on the left, what this recipe makes on the right.';
    $('.yb-verdict').title='Colour difference '+rec.d.toFixed(1);

    var totW=rec.parts.reduce(function(s,p){return s+p.w;},0);
    var totD=Math.max(rec.parts.length, Math.round(DROPS_FULL_16OZ*STEPS[stepIdx]*(batch/16)));
    var rows=rec.parts.map(function(p){
      var s=LIB.filter(function(x){return x.n===p.n;})[0];
      return {n:p.n, drops:Math.max(1,Math.round(totD*p.w/totW)), s:s}; });
    var _f=rows.filter(function(r){ return r.drops>=3; }); if(_f.length) rows=_f;
    $('.yb-recipe').innerHTML = rows.map(function(r){
      return '<tr><td><span class="yb-cellname"><span class="yb-sw" style="background:'+r.s.hex+'"></span>'+
        r.n+'</span></td><td class="yb-num">'+r.drops+'</td><td class="yb-num">1</td></tr>'; }).join('')
      + '<tr><td class="yb-mut">Total</td><td class="yb-num yb-mut">'+
        rows.reduce(function(s,r){return s+r.drops;},0)+' drops</td><td class="yb-num yb-mut">'+rows.length+(rows.length===1?' bottle':' bottles')+'</td></tr>';

    var buyable=rows.filter(function(r){ return r.s.vid; });
    var btn=$('.yb-buy');
    if(buyable.length){
      btn.href='/cart/'+buyable.map(function(r){ return r.s.vid+':1'; }).join(',');
      btn.textContent='Add '+buyable.length+' bottle'+(buyable.length>1?'s':'')+' to cart';
    } else { btn.href='/collections/all'; btn.textContent='Shop colours'; }

    $('.yb-copy').dataset.txt='Colour Mill recipe for '+hex+' \u2014 '+batch+' oz frosting\n'
      + rows.map(function(r){ return r.drops+' drop'+(r.drops>1?'s':'')+' '+r.n; }).join('\n')
      + '\nAdd gradually, mix well, rest 2-4 hours before judging.';
  }

  $('.yb-hexIn').addEventListener('input', function(e){
    var v=e.target.value.trim().replace(/^#?/,'#');
    if(/^#[0-9a-f]{6}$/i.test(v)) setBase(v.toUpperCase());
  });
  $('.yb-pick').addEventListener('input', function(e){ setBase(e.target.value.toUpperCase()); });
  $('.yb-batch').addEventListener('change', function(e){ batch=+e.target.value; renderRamp(); applyTarget(); });
  var pal=$('.yb-palette');
  if(pal) pal.addEventListener('change', function(e){
    palette=e.target.value;
    LIB = activePalette();
    $('.yb-paletteNote').textContent = palette==='kickstarter'
      ? 'Using only the 12 bottles in the Kickstarter Pack.'
      : 'Using the full range of ' + ALL.length + ' shades.';
    applyTarget();
  });
  $('.yb-copy').addEventListener('click', function(e){
    navigator.clipboard.writeText(e.target.dataset.txt||'');
    var t=e.target, o=t.textContent; t.textContent='Copied';
    setTimeout(function(){ t.textContent=o; },1400);
  });

  function boot(list){
    ALL = list.map(function(s){ var rgb=hex2rgb(s.hex);
      return {n:s.n, hex:s.hex, handle:s.handle, vid:s.vid, rgb:rgb, lab:rgb2lab(rgb)}; });
    LIB = activePalette();
    byName={}; ALL.forEach(function(s){ byName[s.n]=s; });
    if($('.yb-paletteNote')) $('.yb-paletteNote').textContent='Using the full range of '+ALL.length+' shades.';
    renderRamp(); applyTarget();
  }
  /* A Liquid for-loop over a collection caps at 50 products, which would silently
     drop shades as the catalogue grows. Fetch the real list instead. */
  fetch('/collections/all/products.json?limit=250')
    .then(function(r){ return r.json(); })
    .then(function(d){
      var out=[];
      (d.products||[]).forEach(function(p){
        var e=YB_HEX[p.handle]; if(!e) return;
        var v=(p.variants||[]).filter(function(x){ return x.title==='20ml'; })[0]||(p.variants||[])[0];
        out.push({n:e[0], hex:e[1], handle:p.handle, vid:v&&v.id});
      });
      if(out.length) boot(out);
      else $('.yb-verdict').textContent='Shade list unavailable. Please refresh.';
    })
    .catch(function(){ $('.yb-verdict').textContent='Shade list unavailable. Please refresh.'; });
})();
